import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';
import './TradeRecapBackModal.css';

/**
 * Trade Recap Back Confirmation Modal
 * 
 * Premium styled modal for confirming navigation away from Trade Recap
 * with unsaved changes. Matches HMS design system with blue gradient
 * header and smooth animations.
 * 
 * @param {Object} props
 * @param {string} props.message - Confirmation message to display
 * @param {Function} props.onConfirm - Callback when user confirms leaving
 * @param {Function} props.onCancel - Callback when user cancels
 * @param {Function} props.onDraft - Optional callback to save as draft before leaving
 */
const TradeRecapBackModal = ({ message, onConfirm, onCancel, onDraft }) => {
  // Prevent modal from closing when clicking inside it
  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  // Close modal when clicking overlay
  const handleOverlayClick = () => {
    onCancel();
  };

  return (
    <div className="trade-recap-back-modal-overlay" onClick={handleOverlayClick}>
      <div className="trade-recap-back-modal" onClick={handleModalClick}>
        {/* Header with HMS Blue Gradient */}
        <div className="trade-recap-back-modal-header">
          <div className="trade-recap-back-header-content">
            <h3 className="trade-recap-back-modal-title">Unsaved Changes</h3>
          </div>
          <button
            className="trade-recap-back-close-btn"
            onClick={onCancel}
            aria-label="Close modal"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {/* Body Content */}
        <div className="trade-recap-back-modal-body">
          {/* Warning Banner */}
          <div className="trade-recap-back-warning-banner">
            <FontAwesomeIcon icon={faExclamationTriangle} size="lg" />
            <div className="trade-recap-back-warning-text">
              <strong>Warning</strong>
              <p>You have unsaved changes that will be lost if you leave this page.</p>
            </div>
          </div>

          {/* Confirmation Question */}
          <div className="trade-recap-back-confirm-message">
            <p className="trade-recap-back-question">
              {message || 'Are you sure you want to go back?'}
            </p>
          </div>
        </div>

        {/* Footer with Action Buttons */}
        <div className="trade-recap-back-modal-footer">
          <button
            className="trade-recap-back-btn-secondary"
            onClick={onCancel}
          >
            Stay on Page
          </button>
          {onDraft && (
            <button
              className="trade-recap-back-btn-draft"
              onClick={onDraft}
            >
              Draft
            </button>
          )}
          <button
            className="trade-recap-back-btn-primary"
            onClick={onConfirm}
          >
            Leave Without Saving
          </button>
        </div>
      </div>
    </div>
  );
};

export default TradeRecapBackModal;


